// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + ({"74":"About","89":"async.dompurify","268":"Home","656":"async.react-helmet","766":"TopRanking","830":"Options"}[chunkId] || chunkId) + "." + __webpack_require__.h().slice(0, 8) + ".chunk.js";
};